export enum MapRoutes {
  QUOTE_FORM = "quoteForm",
  QUOTE_LOGIN = "quoteLogin",
  TO_FORM = "redirectQuoteForm",
  TO_FORM_FROM_OLD_URLS = "redirectQuoteFormFromOldURLs",
  RESULTS = "results",
  COMPARE = "compare",
  TIP = "tip",
  PRODUCT_DETAIL = "productDetail",
  OFFER_DETAIL = "offerDetail",
  PRODUCTS = "products",
  CAPTURE = "capture",
  FILTERS = "filters",
  CAR_DEALER = "carDealer",
  CHECKOUT = "checkout",
  CHECKOUT_FAILURE = "checkoutFailure",
  CHECKOUT_LOGIN = "checkoutLogin",
  CHECKOUT_PENDING_PAYMENT = "checkoutPendingPayment",
  CHECKOUT_STEP = "checkoutStep",
  CHECKOUT_SUCCESS = "checkoutSuccess",
  CHECKOUT_TO_QUOTE = "checkoutToQuote",
  RENEWAL = "renewal",
  RENEWAL_OFFLINE = "renewalOffline",
  SOAP_CROSS_SELLING = "redirectCrossSellingQuoteForm",
  PAYMENT = "payment",
  CICL_PAYMENT_FAILURE = "ciclPaymentFailure",
  CICL_PAYMENT_SUCCESS = "ciclPaymentSuccess"
}
